export const verifyInt = (n, description) => {
    const parsed = parseInt(n, 10);

    if (isNaN(parsed))
        throw new Error(`"${description}" should be a number/integer`);

    return parsed;
};
